import { Typography, Skeleton, Anchor } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface SubscriptionFooterProps {
  learnMoreUrl?: string;
  learnMoreLabel?: string;
  isLoading?: boolean;
}

export const SubscriptionFooter: FC<SubscriptionFooterProps> = ({
  learnMoreLabel,
  learnMoreUrl,
  isLoading,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeleton className="h-4 w-full" />;
  }

  return (
    <div className="flex items-center gap-2">
      <Typography variant="labelMediumBook">{t('SUBSCRIPTIONS.LEARN_MORE_AT')}</Typography>
      <Typography variant="labelMediumBook" asChild>
        <Anchor href={learnMoreUrl}>{learnMoreLabel}</Anchor>
      </Typography>
    </div>
  );
};
